<template>
  <div style="margin-inline: 15px;">
    <v-row class="ma-2">
      <v-btn
          small
          class="ma-2"
          @click="addRow()">
        Добавить
      </v-btn>
      <v-btn
          :disabled="rowsForDelete.length<=0"
          small
          class="ma-2"
          @click="multiDelete()">
        Удалить
      </v-btn>
      <v-btn
          small
          :disabled="rowsForDelete.length<=0"
          class="ma-2"
          @click="rowsForDelete=[]">
        Отменить выбор
      </v-btn>
      <v-spacer/>
      <v-btn
          :disabled="(!(changes.updatingRows.length > 0 || changes.addedRows.length > 0 || changes.deletedRows.length > 0))"
          small
          class="ma-2"
          @click="checkErrors()?'':windowSave=true">
        Сохранить
      </v-btn>
      <v-btn
          small
          class="ma-2"
          @click="(changes.updatingRows.length > 0 || changes.addedRows.length > 0 || changes.deletedRows.length > 0)?windowAlert=true:rollback()">
        Отменить
      </v-btn>
    </v-row>
    <v-data-table
        :loading="loadingData"
        v-model="rowsForDelete"
        :headers="headerTable"
        :items="filteredDesserts"
        item-key="id"
        :item-class="itemClasses"
        :page.sync="page"
        :items-per-page="20"
        @page-count="pageCount = $event"
        class="elevation-1"
        show-select
        hide-default-footer
        dense
    >
      <template v-slot:footer>
        <div style="display: flex; border-top:thin solid rgba(0,0,0,.12);">
          <v-spacer/>
          <v-switch hide-details style="padding: 5px; margin-top: auto; margin-bottom: auto" label="Подробнее"
                    v-model="isWithDevice"/>
        </div>
      </template>
      <template v-slot:header.post_id="{ header }">
        {{ header.text }}
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    :color="postFilterValue ? 'primary' : ''"
                    v-bind="attrs"
                    v-on="on"
            >
              mdi-filter
            </v-icon>
          </template>
          <v-list>
            <v-btn text @click="postFilterValue = null" class="ms-5 me-5 mb-2" small>Очистить фильтр
              <v-icon right>
                mdi-filter-remove
              </v-icon>
            </v-btn>
            <v-divider></v-divider>
            <v-list-item
                v-for="(post) in posts"
                :key="post.id"
                @click="postFilterValue = post.id"
                link>
              <v-list-item-content>
                <v-list-item-title>{{ post.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:header.sensor_type_id="{header}">
        {{ header.text }}
        <v-menu :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small
                    :color="sensorFilterValue.length>0 ? 'primary' : ''"
                    v-bind="attrs"
                    v-on="on">
              mdi-filter
            </v-icon>
          </template>
          <v-list>
            <v-btn text @click="sensorFilterValue=[]" class="ms-5 me-5 mb-2" small>Очистить фильтр
              <v-icon right>
                mdi-filter-remove
              </v-icon>
            </v-btn>
            <v-divider></v-divider>
            <v-list-item-group
                multiple
                v-model="sensorFilterValue">
              <v-list-item
                  v-for="(sensor) in sensorTypes"
                  :key="sensor.id"
                  :value="sensor.id">
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ sensor.name }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.actions="{ item }" style="padding: 0">
        <v-btn style="margin: auto" x-small
               :title="`Копирование записи \nПКМ - множественное копирование`"
               @click="cloningRow(item,1)"
               @contextmenu="showMenu($event,item)">
          Копировать
        </v-btn>
        <v-menu
            v-if="item===menu.menuItem"
            v-model="menu.showMenu"
            :position-x="menu.x"
            :position-y="menu.y"
            absolute
            :close-on-content-click="false"
            offset-y>
          <v-card elevation="2">
            <v-card-title class="text-h5 mb-1">
              Количество копий:
            </v-card-title>
            <v-text-field min="1" suffix="шт." v-model:number="numberOfCopies" type="number"
                          class="ms-5 me-5"></v-text-field>
            <v-card-actions>
              <v-btn
                  outlined
                  rounded
                  text
                  @click="cloningRow(item,numberOfCopies)">
                Копировать
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </template>
      <template v-slot:item.post_id="{isMobile, item, value, header}">
        <list
            :isMobile="isMobile"
            :value="item[header.value]"
            :list="posts"
            keyList="id"
            :required="header.required"
            :functionCheckChange="isUpdated(item.id,header.value)"
            @change="updateRow(item,$event,header.value)"
        />
      </template>
      <template v-slot:item.sensor_type_id="{isMobile, item, value, header}">
        <list
            :isMobile="isMobile"
            :value="item[header.value]"
            :list="sensorTypes"
            :required="header.required"
            keyList="id"
            :functionCheckChange="isUpdated(item.id,header.value)"
            @change="updateRow(item,$event,header.value)"/>
      </template>
      <template v-slot:item.device_id="{isMobile, item, value, header}">
        <list
            :isMobile="isMobile"
            :value="item[header.value]"
            :list="devices"
            :required="header.required"
            keyList="id"
            :functionCheckChange="isUpdated(item.id,header.value)"
            @change="updateRow(item,$event,header.value)"/>
      </template>
      <template v-slot:item.date_start="{ item, value, header}">
        <v-text-field
            class="date cell"
            dense
            :required="true"
            :value="formatDateForInputDate(value)"
            hide-details
            single-line
            :min="'2000-01-01T00:00'"
            type="datetime-local"
            @change="updateRow(item,new Date($event).toJSON(), header.value)"
        >
          <template v-slot:append>
            <v-icon size="10"
                    v-if="!validateDate(item)"
                    color="red"
                    class="error-dot">mdi-circle
            </v-icon>
            <v-icon size="10" v-else-if="isUpdated(item.id,header.value)" color="yellow" class="update-dot">
              mdi-circle
            </v-icon>
          </template>
        </v-text-field>
      </template>
      <template v-slot:item.date_end="{ item, value, header}">
        <v-text-field
            class="date cell"
            :value="formatDateForInputDate(value)"
            dense
            hide-details
            single-line
            :min="formatDateForInputDate(item.date_start)"
            type="datetime-local"
            @change="updateRow(item,new Date($event).toJSON(), header.value)"
        >
          <template v-slot:append>
            <v-icon
                v-if="!validateDate(item)"
                size="10"
                color="red"
                class="error-dot">
              mdi-circle
            </v-icon>
            <v-icon v-else-if="isUpdated(item.id,header.value)"
                    size="10"
                    color="yellow"
                    class="update-dot">
              mdi-circle
            </v-icon>
          </template>
        </v-text-field>
      </template>
      <template v-slot:item.cause_id="{isMobile, item, value, header}">
        <list
            :isMobile="isMobile"
            :value="item[header.value]"
            :list="causes"
            keyList="id"
            :required="header.required"
            :functionCheckChange="isUpdated(item.id,header.value)"
            @change="updateRow(item,$event,header.value)"/>
      </template>
      <template v-slot:item.comment="{isMobile, item, value, header }">
        <v-edit-dialog
            save-text="Сохранить"
            cancel-text="Отменить"
            large
            v-bind:style="isMobile&&value===null?'min-width: 150px;':''"
            @open="editable=value"
            @save="updateRow(item,editable,header.value);editable=value"
            @cancel="editable = null">
          <span v-bind:class="isUpdated(item.id,header.value) ? 'updated' : ''">{{ value || ' ' }}</span>
          <template v-slot:input>
            <v-textarea
                class="mt-3"
                rows="4"
                no-resize
                filled
                v-model="editable"
                dense
                hide-details
                single-line
            />
          </template>
        </v-edit-dialog>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
          class="my-4"
          v-model="page"
          :length="pageCount"
          :total-visible="7"
      />
    </div>
    <v-dialog v-model="windowSave" width="500" persistent>
      <v-card>
        <v-alert type="warning" :value="true"> Внимание!
        </v-alert>
        <v-card-text class="text-md-center">
          <v-textarea
              readonly
              value="Внести изменения?"
              rows="1"
              flat
              solo
              auto-grow
              dense>
          </v-textarea>
        </v-card-text>
        <v-card-actions class="text-lg-right">
          <v-spacer/>
          <v-btn @click="windowSave = false; save()">
            Да
          </v-btn>
          <v-btn @click="windowSave = false;">
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="windowAlert" width="500" persistent>
      <v-card>
        <v-alert type="warning" :value="true"> Внимание!
        </v-alert>
        <v-card-text class="text-md-center">
          <v-textarea
              readonly
              value="Отменить изменения?"
              rows="1"
              flat
              solo
              auto-grow
              dense>
          </v-textarea>
        </v-card-text>
        <v-card-actions class="text-lg-right">
          <v-spacer/>
          <v-btn @click="windowAlert = false; rollback()">
            Да
          </v-btn>
          <v-btn @click="windowAlert = false;">
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import axios from "axios";
import {bus} from "@/main";
import List from "@/components/List.vue"

export default {
  components: {List},
  comments: {
    'list': List
  },
  data() {
    return {
      windowSave: false,
      windowAlert: false,
      numberOfCopies: 1,
      isWithDevice: false,

      selectedFile: null,
      page: 1,
      pageCount: 20,

      editable: null,
      postFilterValue: null,
      sensorFilterValue: [],

      headerTable: [
        {
          text: 'Действия',
          align: 'center',
          required: false,
          sortable: false,
          value: 'actions',
          divider: true,
          width: 80
        },
        {
          text: 'Пост',
          required: true,
          align: 'start',
          sortable: false,
          value: 'post_id',
          divider: true,
          width: 300,
        },
        {
          text: 'Тип сенсора',
          align: 'start',
          required: true,
          sortable: false,
          value: 'sensor_type_id',
          divider: true,
          width: 300,
        },
        {
          text: 'Дата начала',
          align: 'start',
          required: true,
          sortable: false,
          value: 'date_start',
          divider: true,
          width: 270,
        },
        {
          text: 'Дата конца',
          align: 'start',
          required: true,
          sortable: false,
          value: 'date_end',
          divider: true,
          width: 270,
        },
        {
          text: 'Примечание',
          align: 'start',
          required: false,
          sortable: false,
          value: 'comment',
          divider: true,
          width: 200
        }
      ],
      exceptions: [],
      copyExceptions: [],
      posts: [],
      sensorTypes: [],
      devices: [],
      causes: [],
      rowsForDelete: [],
      changes: {
        updatingRows: [],
        addedRows: [],
        deletedRows: []
      },
      listUUID: [],
      menu: {
        menuItem: null,
        showMenu: false,
        x: 0,
        y: 0,
      },
      file: [],
      badDate: [],
      badRepeat: [],
      badPeriod: [],
      selectedYear: new Date().getFullYear(),
    }
  },
  watch: {
    isWithDevice() {
      if (this.isWithDevice) {
        this.headerTable.push({
              text: 'Прибор',
              align: 'start',
              required: false,
              sortable: false,
              value: 'device_id',
              divider: true,
            },
            {
              text: 'Причина',
              align: 'start',
              required: false,
              sortable: false,
              value: 'cause_id',
              divider: true,
            })
      } else {
        this.headerTable.splice(-2, 2)
      }
    }
  },
  computed: {
    filteredDesserts() {
      let conditions = [];
      if (this.postFilterValue) {
        conditions.push(this.filterPost);
      }
      if (this.sensorFilterValue.length > 0) {
        conditions.push(this.filterSensor);
      }
      if (conditions.length > 0) {
        return this.exceptions.filter((exception) => {
          return conditions.every((condition) => {
            return condition(exception);
          })
        })
      }
      return this.exceptions;
    },
    //TODO переделать на флаги загрузки данных
    loadingData() {
      return !(this.posts.length > 0 && this.sensorTypes.length > 0 && this.exceptions.length > 0);
    },
  },
  methods: {
    log(ms) {
      console.log(ms)
    },
    // возвращает строчку с датой в локальном времени в формате для input type=datetime-local
    formatDateForInputDate(dateString) {
      const date = new Date(dateString)
      return date.getFullYear() + '-' + (date.getMonth() + 101).toString().slice(-2) + '-' + (date.getDate() + 100).toString().slice(-2) +
          'T' + (date.getHours() + 100).toString().slice(-2) + ':' + (date.getMinutes() + 100).toString().slice(-2)
    },
    // возвращает строчку с датой в локальном времени в формате для отображения людям
    formatDateForHuman(dateString) {
      const date = new Date(dateString)
      return date.getFullYear() + '-' + (date.getMonth() + 101).toString().slice(-2) + '-' + (date.getDate() + 100).toString().slice(-2) +
          ' ' + (date.getHours() + 100).toString().slice(-2) + ':' + (date.getMinutes() + 100).toString().slice(-2)
    },

    itemClasses(item) {
      return {
        added: this.changes.addedRows.length > 0 ? this.changes.addedRows.filter(j => j.id === item.id).length > 0 : false,
        errorDate: this.badDate.length > 0 ? this.badDate.includes(item.i, 0) : false,
        errorRepeat: this.badRepeat.length > 0 ? this.badRepeat.includes(item.id, 0) : false,
        errorPeriod: this.badPeriod.length > 0 ? this.badPeriod.includes(item.id, 0) : false,
      }
    },
    isUpdated(rowId, col) {
      for (const row of this.changes.updatingRows) {
        if (rowId === row.old.id) {
          return row.old[col] !== row.new[col];
        }
      }
      return false
    },
    validateDate(item) {
      if (item.date_start === '' || item.date_end === '' || item.date_start === null || item.date_end === null) {
        return false
      }
      return !(new Date(item.date_start) >= new Date(item.date_end) ||
          new Date(item.date_start) < new Date('2000-01-01T00:00') ||
          new Date(item.date_end) < new Date('2000-01-01T00:00'));

    },

    checkErrors() {
      this.badDate = []
      this.badRepeat = []
      this.badPeriod = []
      const checkIntersection = function (row, row2) {
        return (new Date(row.date_start) < new Date(row2.date_end) &&
            new Date(row2.date_start) < new Date(row.date_end) ||
            row.date_start === row2.date_start ||
            row.date_end === row2.date_end)
      }
      bus.$emit('message-reset', {})
      let flagError = false
      //Проверка добавленных строк на пустые поля и дубли
      addedRows: for (let i = 0; i < this.changes.addedRows.length; i++) {
        const row = this.changes.addedRows[i]
        //Проверка на дубли
        for (let j = 0; j < this.exceptions.length; j++) {
          const row2 = this.exceptions[j]
          if (row.id !== row2.id &&
              row.post_id === row2.post_id &&
              row.sensor_type_id === row2.sensor_type_id &&
              row.date_start === row2.date_start &&
              row.date_end === row2.date_end
          ) {
            //Удаляем дубли
            this.deleteRow(row.id)
            i--
            continue addedRows
          }
        }
        //Проверка на пустые поля
        for (const argumentsKey in row) {
          if ((row[argumentsKey] === null || row[argumentsKey] === '') && this.headerTable.filter(item => {
            item.value === argumentsKey
          })[0]?.required) {
            bus.$emit('message-add', {
              message: "Заполните пустые ячейки",
              color: "red",
              timeout: -1
            });
            flagError = true
            break;
          }
        }
      }
      //Проверка на пересечение периодов дат
      for (let i = 0; i < this.changes.addedRows.length; i++) {
        const changesRow = this.changes.addedRows[i]
        for (let j = 0; j < this.exceptions.length; j++) {
          const row2 = this.exceptions[j]
          if ((changesRow.id !== row2.id && changesRow.post_id === row2.post_id && changesRow.sensor_type_id === row2.sensor_type_id)
              && checkIntersection(changesRow, row2)) {
            if (!this.badPeriod.includes(changesRow.id, 0) && !this.badPeriod.includes(row2.id, 0)) {
              bus.$emit('message-add', {
                message: "Периоды дат пересекаются\n" +
                    "Пост: " + this.posts.filter(item => item.id === changesRow.post_id)[0].name + "\n" +
                    "Тип сенсора: " + this.sensorTypes.filter(item => item.id === changesRow.sensor_type_id)[0].name + "\n" +
                    this.formatDateForHuman(changesRow.date_start) + " - " +
                    this.formatDateForHuman(changesRow.date_end) + "\n" +
                    this.formatDateForHuman(row2.date_start) + " - " +
                    this.formatDateForHuman(row2.date_end) + "\n",
                color: "#28dcff",
                timeout: -1,
              });
              this.badPeriod.push(changesRow.id)
              flagError = true
            }
          }
        }
      }
      //Проверка обновленных строк на пустые поля, дубли и пересечение дат
      for (let i = 0; i < this.changes.updatingRows.length; i++) {
        const Updatedrow = this.changes.updatingRows[i].new
        //Проверка на пустые поля
        for (const argumentsKey in Updatedrow) {
          if ((Updatedrow[argumentsKey] === null || Updatedrow[argumentsKey] === '') && this.headerTable.filter(item => {
            item.value === argumentsKey
          })[0]?.required) {
            bus.$emit('message', {
              message: "Заполните пустые ячейки",
              color: "red",
              timeout: -1,
            });
            flagError = true
          }
        }
        for (let j = 0; j < this.exceptions.length; j++) {
          const row2 = this.exceptions[j]
          if (Updatedrow.id !== row2.id && Updatedrow.post_id === row2.post_id && Updatedrow.sensor_type_id === row2.sensor_type_id) {
            if (Updatedrow.date_start === row2.date_start && Updatedrow.date_end === row2.date_end) {
              this.badRepeat.push(Updatedrow.id)
              this.badRepeat.push(row2.id)
              bus.$emit('message-add', {
                message: "Есть повторяющиеся строки \n" +
                    "Пост: " + this.posts.filter(item => item.id === Updatedrow.post_id)[0].name + "\n" +
                    "Тип сенсора: " + this.sensorTypes.filter(item => item.id === Updatedrow.sensor_type_id)[0].name + "\n" +
                    "Дата начала: " + Updatedrow.date_start.replace('T', ' ') + "\n" +
                    "Дата конца: " + Updatedrow.date_end.replace('T', ' '),
                color: "#ffab00",
                timeout: -1
              });
              flagError = true
            } else if (new Date(Updatedrow.date_start) < new Date(row2.date_end) &&
                checkIntersection(Updatedrow, row2)) {
              if (!this.badPeriod.includes(Updatedrow.id, 0) && !this.badPeriod.includes(row2.id, 0)) {
                bus.$emit('message-add', {
                  message: "Периоды дат пересекаются\n" +
                      "Пост: " + this.posts.filter(item => item.id === Updatedrow.post_id)[0].name + "\n" +
                      "Тип сенсора: " + this.sensorTypes.filter(item => item.id === Updatedrow.sensor_type_id)[0].name + "\n" +
                      this.formatDateForHuman(Updatedrow.date_start) + " - " +
                      this.formatDateForHuman(Updatedrow.date_end) + "\n" +
                      this.formatDateForHuman(row2.date_start) + " - " +
                      this.formatDateForHuman(row2.date_end) + "\n",
                  color: "#28dcff",
                  timeout: -1,
                });
                this.badPeriod.push(Updatedrow.id)
                flagError = true
              }
            }
          }
        }
      }
      //Проверка коректности дат
      for (const exception of this.exceptions) {
        if (!(exception.date_start === '' || exception.date_end === '')) {
          if (new Date(exception.date_start) >= new Date(exception.date_end) ||
              (new Date(exception.date_start) < new Date('1753-01-01T00:00')) ||
              (new Date(exception.date_end) < new Date('1753-01-01T00:00'))) {
            this.badDate.push(exception.id)
            bus.$emit('message-add', {
              message: "Некоректно введена дата\n" +
                  "Пост: " + this.posts.filter(item => item.id === exception.post_id)[0].name + "\n" +
                  "Тип сенсора: " + this.sensorTypes.filter(item => item.id === exception.sensor_type_id)[0].name + "\n" +
                  "Дата начала: " + this.formatDateForHuman(exception.date_start) + "\n" +
                  "Дата конца: " + this.formatDateForHuman(exception.date_end),
              color: "red",
              timeout: -1
            });
            flagError = true
          }
        }
      }

      if (this.changes.updatingRows?.new?.length === 0 && this.changes.addedRows?.length === 0 && this.changes.deletedRows.length === 0) {
        return true
      }

      return flagError
    },

    filterPost(value) {
      return value.post_id === this.postFilterValue || value.post_id === null
    },
    filterSensor(value) {
      return this.sensorFilterValue.includes(value.sensor_type_id) || value.sensor_type_id === null
    },

    showMenu(e, item) {
      this.menu.menuItem = item
      e.preventDefault()
      this.menu.showMenu = false
      this.menu.x = e.clientX
      this.menu.y = e.clientY
      this.$nextTick(() => {
        this.menu.showMenu = true
      })
    },
    reset() {
      this.rowsForDelete = []
      this.badDate = []
      this.badRepeat = []
      this.badPeriod = []
      this.listUUID = []
      this.changes = {
        updatingRows: [],
        addedRows: [],
        deletedRows: []
      }
    },
    rollback() {
      bus.$emit("message-reset")
      this.reset()
      this.exceptions = structuredClone(this.copyExceptions)
    },
    getRow(id) {
      for (let i = 0; i < this.exceptions.length; i++) {
        if (this.exceptions[i].id === id) {
          return {row: this.exceptions[i], index: i}
        }
      }
    },

    addRow() {
      let newRow = {
        id: this.genUUID(),
        post_id: null,
        sensor_type_id: null,
        device_id: null,
        cause_id: null,
        date_start: '',
        date_end: '',
        comment: ''
      }
      this.exceptions.unshift(newRow)
      this.changes.addedRows.push(newRow)
    },
    multiDelete() {
      for (const row of this.rowsForDelete) {
        this.deleteRow(row.id)
      }
      this.rowsForDelete = []
    },
    deleteRow(itemId) {
      const row = this.getRow(itemId).row
      this.exceptions.splice(this.getRow(itemId).index, 1)
      //Если в начале id находится #, то это добавленная стока
      if (itemId[0] === '#') {
        for (let i = 0; i < this.changes.addedRows.length; i++) {
          if (this.changes.addedRows[i].id === itemId) {
            this.changes.addedRows.splice(i, 1)
            this.deleteUUID(itemId)
            return
          }
        }
      }
      for (let i = 0; i < this.changes.updatingRows.length; i++) {
        let row = this.changes.updatingRows[i]
        if (row.new.id === itemId) {
          this.changes.deletedRows.push(row.old)
          this.changes.updatingRows.splice(i, 1)
          return;
        }
      }
      this.changes.deletedRows.push(row)
    },
    cloningRow(item, number) {
      for (let i = 0; i < number; i++) {
        let newRow = Object.assign({}, item)
        newRow.id = this.genUUID()
        this.exceptions.unshift(newRow)
        this.changes.addedRows.push(newRow)
      }
      this.numberOfCopies = 1
      this.menu.showMenu = false
    },
    updateRow(item, value, column) {
      //Если строка не поменялась, то ничего не делаем
      if (item[column] === value) {
        return;
      }
      // Если в строчке id начинается на #, то она была добавлена
      if (item.id[0] === '#') {
        item[column] = value
        return;
      }
      // Если строка уже обновлялась, то только обновлем из списка обновленных
      for (let i = 0; i < this.changes.updatingRows.length; i++) {
        const updatingRow = this.changes.updatingRows[i]
        if (item.id === updatingRow.old.id) {
          // Если строчка обновление совпадает со старой версией,
          // то удаляем ее из списка обновленных
          if (this.isEqual(item, updatingRow.old)) {
            this.changes.updatingRows.splice(i, 1)
            return;
          }
          updatingRow.new[column] = value
          return;
        }
      }
      // Если строка до этого не менялась, то добавляем ее версию до изменения old и новую версию new
      const oldItem = Object.freeze(Object.assign({}, item))
      item[column] = value
      console.log(this.changes.updatingRows.at(-1))
      this.changes.updatingRows.push({old: oldItem, new: item})
    },

    isEqual(obj1, obj2) {
      for (const Key in obj1) {
        if (obj1[Key] !== obj2[Key]) {
          return false
        }
      }
      return true
    },
    genUUID() {
      let UUID = Math.floor(Math.random() * 900000 + 1000)
      if (this.listUUID.includes(UUID)) {
        UUID = this.genUUID()
      } else {
        this.listUUID.push(UUID)
      }
      return '#' + UUID
    },
    deleteUUID(id) {
      this.listUUID.splice(this.listUUID.indexOf(id.slice(1)), 1)
    },

    save() {
      axios
          .post("/api/exceptions/save", {
            addedRows: this.changes.addedRows.map(row => {
              row.id = 0
              return row
            }),
            updatedRows: this.changes.updatingRows,
            deletedRows: this.changes.deletedRows
          })
          .then(() => {
            this.reset()
            bus.$emit('message', {
              message: "Данные успешно сохранены",
              color: "green"
            });
            setTimeout(() => this.getExceptions(), 10)
          })
          .catch(() => {
            bus.$emit('message', {
              message: "Ошибка сохранения данных",
              color: "red"
            });
          });
    },
    getSensorTypes() {
      axios
          .get("/api/sensor-types/get/all")
          .then(response => {
            this.sensorTypes = response.data
          })
          .catch(() => {
            bus.$emit('message', {
              message: "Ошибка при получении сенсоров",
              color: "red"
            });
          });
    },
    getExceptions() {
      axios
          .get("/api/exceptions/get/all")
          .then(response => {
            this.exceptions = response.data
            this.copyExceptions = structuredClone(response.data)
          })
          .catch(() => {
            bus.$emit('message', {
              message: "Ошибка при получении исключений",
              color: "red"
            });
          })
    },
    getPosts() {
      axios
          .get("/api/post/get/all")
          .then(response => {
            this.posts = response.data
          })
          .catch(() => {
            bus.$emit('message', {
              message: "Ошибка при получении постов",
              color: "red"
            });
          });
    },
    getDevices() {
      axios
          .get("/api/device/get/all")
          .then(response => {
            this.devices = response.data
          })
          .catch(() => {
            bus.$emit('message', {
              message: "Ошибка при получении приборов",
              color: "red"
            });
          });
    },
    getCauses() {
      axios
          .get("/api/cause/get/all")
          .then(response => {
            this.causes = response.data
          })
          .catch(() => {
            bus.$emit('message', {
              message: "Ошибка при получении причин",
              color: "red"
            });
          });
    },
    /*    logout() {
          axios
              .post("/api/auth/logout", {})
              .then(response => {
                console.log(response.status)
              })
              .catch(() => {
                bus.$emit('message', {
                  message: "Ошибка во время выхода. Перезагрузите стринцу и попробуйте снова.",
                  color: "red"
                });
              });
        }*/
  },
  created() {
    bus.$emit('message-reset')
    this.getExceptions()
    this.getPosts()
    this.getSensorTypes()
    this.getDevices()
    this.getCauses()
  }
}
</script>
<style scoped>

.v-data-table >>> .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
  opacity: 0 !important;
}

.v-data-table >>> .theme--light.v-text-field:not(.v-input--has-state):hover > .v-input__control > .v-input__slot:before {
  opacity: 0 !important;
}

.v-data-table >>> tr.added {
  background-color: #f4ffc4 !important;
}

.v-data-table >>> tr.errorDate {
  background-color: rgba(229, 56, 56, 0.55) !important;
}

.v-data-table >>> tr.errorRepeat {
  background-color: #ffab00 !important;
}

.v-data-table >>> tr.errorPeriod {
  background-color: #28dcff !important;
}

.v-data-table >>> td {
  padding: 0 10px !important;
}

.v-data-table >>> th {
  padding: 0 10px !important;
}


.v-data-table >>> tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).added {
  filter: brightness(0.95) !important;
}

.date {
  margin: auto;
}

.date .v-icon {
  position: absolute;
  margin-left: -32px;
}

.date >>> .v-input__append-inner {
  padding: 0 !important;
}

.cell {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
}

.update-dot {
  margin-top: 3px;
}

.error-dot {
  margin-top: 3px;
}

.v-list {
  height: 350px; /* or any height you want */
  overflow-y: auto
}

/*th {
  vertical-align: middle;
  text-align: left;
  padding: 0 16px;
  user-select: none;
  font-size: 0.75rem;
  height: 32px;
  color: rgba(0, 0, 0, 0.6);
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  border-right: thin solid rgba(0, 0, 0, 0.12);
}*/
</style>